(function () {
  'use strict';
  var CODE = 'WELCOME10', FLAG = 'outdoer_welcome_signup', BANNER = 'outdoer-welcome-banner';
  try { if (/[?&]welcometest=1/.test(location.search)) localStorage.setItem(FLAG, 'active'); } catch (e) {}
  window.addEventListener('klaviyoForms', function (e) {
    try { if (e && e.detail && e.detail.type === 'submit') localStorage.setItem(FLAG, 'active'); } catch (err) {}
  });
  function active() { try { return localStorage.getItem(FLAG) === 'active'; } catch (e) { return false; } }
  function alreadyApplied(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = (c.discount_codes || []).map(function (d) { return String(d.code || '').toUpperCase(); });
        var apps = (c.cart_level_discount_applications || []).map(function (a) { return String(a.title || '').toUpperCase(); });
        cb(codes.indexOf(CODE) > -1 || apps.indexOf(CODE) > -1);
      }).catch(function () { cb(false); });
  }
  function makeBanner() {
    var d = document.createElement('div');
    d.className = BANNER;
    d.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:12px;margin:12px 0;padding:12px 14px;border:1px dashed #3F5A56;border-radius:4px;background:#ECEBE7;font-family:Arial,Helvetica,sans-serif;';
    d.innerHTML = '<div style="line-height:1.35;"><div style="font-size:10px;letter-spacing:2px;color:#6A5F50;">YOUR WELCOME CODE</div><div style="font-size:16px;font-weight:700;color:#3C352B;letter-spacing:1px;">' + CODE + ' \u2014 10% off</div></div><button type="button" style="flex:0 0 auto;background:#3F5A56;color:#fff;border:none;border-radius:2px;padding:10px 18px;font-size:13px;font-weight:700;letter-spacing:1px;cursor:pointer;">Apply</button>';
    d.querySelector('button').addEventListener('click', function () { window.location.href = '/discount/' + CODE + '?redirect=/cart'; });
    return d;
  }
  function hosts() {
    var l = [];
    var p = document.querySelector('.cart-page__items');
    if (p && p.parentNode) l.push({ parent: p.parentNode, ref: p });
    var dr = document.querySelector('cart-drawer');
    if (dr) { var di = dr.querySelector('.cart-page__items, cart-items-component, .cart-items'); if (di && di.parentNode) l.push({ parent: di.parentNode, ref: di }); }
    return l;
  }
  var checking = false;
  function inject() {
    if (!active()) return;
    var need = hosts().filter(function (h) { return !h.parent.querySelector('.' + BANNER); });
    if (!need.length || checking) return;
    checking = true;
    alreadyApplied(function (applied) {
      checking = false;
      if (applied) return;
      need.forEach(function (h) { if (!h.parent.querySelector('.' + BANNER)) h.parent.insertBefore(makeBanner(), h.ref); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inject); else inject();
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[href*="/cart"], cart-icon, [class*="cart-icon"], [aria-label*="art" i]')) setTimeout(inject, 400);
  }, true);
  try { new MutationObserver(function () { if (active()) inject(); }).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
